
// Connection error handling utilities

interface ConnectionError extends Error {
  code?: string;
  details?: string;
  hint?: string;
}

export const isOnline = (): boolean => {
  return typeof navigator !== 'undefined' ? navigator.onLine : true;
};

export const handleConnectionError = (error: any, context: string = 'Unknown') => {
  console.error(`[${context}] Connection error:`, error);
  
  // Check for common Supabase connection issues
  if (error?.message?.includes('Failed to fetch') || 
      error?.message?.includes('NetworkError') ||
      error?.message?.includes('ERR_NETWORK') ||
      error?.code === 'NETWORK_ERROR') {
    console.error('Network connectivity issue detected');
    return;
  }
  
  // Check for authentication issues
  if (error?.code === '401' || error?.message?.includes('JWT')) {
    console.error('Authentication error detected');
    return;
  }
  
  // Check for rate limiting
  if (error?.code === '429' || error?.message?.includes('rate limit')) {
    console.error('Rate limit exceeded');
    return;
  }
  
  // Log other errors for debugging
  console.error('Unhandled error:', error);
};

export const initializeConnectionMonitoring = () => {
  if (typeof window === 'undefined') return;

  let reconnectAttempts = 0;
  const maxReconnectAttempts = 3;

  window.addEventListener('online', () => {
    console.log('Connection restored');
    reconnectAttempts = 0;
    // Trigger a page reload to refresh data
    if (reconnectAttempts === 0) {
      window.location.reload();
    }
  });

  window.addEventListener('offline', () => {
    console.log('Connection lost');
  });
};

export const setupConnectionMonitoring = initializeConnectionMonitoring;

// Initialize connection monitoring
if (typeof window !== 'undefined') {
  initializeConnectionMonitoring();
}
